<script setup lang="ts">
/**
 * Renders an icon inside an `IconField`. Pair with PrimeIcon name via the
 * default slot or `class` attribute (`pi pi-search`).
 */
import PrimeInputIcon from 'primevue/inputicon'
</script>

<template>
  <PrimeInputIcon>
    <slot />
  </PrimeInputIcon>
</template>
